<mat-drawer-container [hasBackdrop]="true">
    <mat-drawer #sidenav [mode]="'over'">
        <app-template-list-filter-sidebar
            [filterForm]="filterForm"
            (closeButtonClicked)="sidenav.close()"
            [typeList]="formattedTypeList"
            [industryList]="formattedIndustryList"></app-template-list-filter-sidebar>
    </mat-drawer>
    <mat-drawer-content class="list-body">
        <app-template-list-filter-topbar
            [filterForm]="filterForm"
            [currentFilters]="currentFilters"
            (filterButtonClicked)="sidenav.open()"
            [typeList]="formattedTypeList"
            [industryList]="formattedIndustryList"></app-template-list-filter-topbar>

        @if (rows.length) {
            <app-table-header
                *appDesktop
                [columns]="columns"
                [gridTemplate]="'repeat(' + columns.length + ', 1fr) 2fr'"
                [isSortable]="true"
                [currentSorting]="currentSorting"
                (sortSelected)="setSorting($event)"></app-table-header>

            <div class="template-list-wrapper">
                @for (formTemplate of rows; track formTemplate._id) {
                    <app-template-card
                        [template]="formTemplate"
                        [columns]="columns"
                        [gridTemplate]="'repeat(' + columns.length + ', 1fr) 2fr'"
                        [formTypeList]="formTypeList"></app-template-card>
                }
            </div>
        }

        @if (loading) {
            <app-loading-indicator></app-loading-indicator>
        } @else if (!rows.length) {
            @if (loadFailed) {
                <app-empty-state illustration="error">
                    <button type="button" class="btn-secondary" (click)="reload()">Try Again</button>
                </app-empty-state>
            } @else if (hasActiveFilters) {
                <app-empty-state
                    illustration="search"
                    title="No Matching Templates"
                    message="There are no results for your set filters. Clear them to see all templates.">
                    <button type="button" class="btn-secondary" (click)="clearFilters()">Clear Filters</button>
                </app-empty-state>
            } @else if (isOwnedTab) {
                <app-empty-state
                    title="No Templates Yet"
                    message="You do not own any report templates yet. Add one from the General tab, or start a new report of your own.">
                </app-empty-state>
            } @else {
                <app-empty-state
                    title="No Templates Yet"
                    message="Report templates published by RISE will appear here.">
                </app-empty-state>
            }
        }
    </mat-drawer-content>
</mat-drawer-container>
